import type {TargetEntity} from '@/features/agenda/hooks/useAgendaAppointmentEventData'
import {StyledAgendaEventReplacedName} from '@/features/agenda/components/agenda-event-target-names/style'
import {Fragment} from 'react'

interface AgendaEventTargetNamesProps {
    targetEntities: TargetEntity[]
    fullNames: string
}

/**
 * Renders the event target names. When at least one consultant has been replaced by a substitute,
 * the names are listed with the replaced ones struck through (the substitute is shown in the
 * substitution badge); otherwise the pre-computed `fullNames` string is rendered as is.
 */
export const AgendaEventTargetNames = ({targetEntities, fullNames}: AgendaEventTargetNamesProps) => {
    const hasSubstitute = targetEntities.some(targetEntity => !!targetEntity.substituteFullName)

    if (!hasSubstitute) return <>{fullNames}</>

    return (
        <>
            {targetEntities.map((targetEntity, index) => (
                <Fragment key={index}>
                    {index > 0 && ', '}
                    {targetEntity.substituteFullName ? (
                        <StyledAgendaEventReplacedName>{targetEntity.entity?.fullName}</StyledAgendaEventReplacedName>
                    ) : (
                        targetEntity.entity?.fullName
                    )}
                </Fragment>
            ))}
        </>
    )
}
